import moment from "moment";

export const STRINGS = {
	ObrigatorioSelecionarMensagem: "É necessário selecionar ao menos uma mensagem de destino",


	TituloConfirmacaoExclusao: 'Deseja Excluir?',
	MensagemConfirmacaoExclusao: 'O registro será excluído permanentemente.',
	TituloShouldNavigate: 'Deseja Continuar?',
	MensagemShouldNavigate: 'As informações que não foram salvas serão perdidas.',
	MensagemSuccessSave: 'Registro salvo com Sucesso.',

	MaiorDoQueZero: 'Deve ser maior do que zero.',
	Obrigatorio: 'Campo obrigatório.',
	DataMaiorDoQueHoje: 'Data não pode ser anterior a hoje',
	MensagemPedidoFabricaRacao: 'Pedido criado pela fábrica de ração',
	CamposInvalidos: 'Por favor, corrija os campos inválidos.',
	ExcedeuLimiteCaracteres: 'Limite de caracteres excedido.',
}

export const MODELS = {
	MENSAGEM_MERCADO_DESTINO: function MENSAGEM_MERCADO_DESTINO(
			dsMensagemBoletimSanitario = '',
			idMensagemBoletimSanitario = 0,
			id = 0) {
		this.dsMensagemBoletimSanitario = dsMensagemBoletimSanitario
		this.idMensagemBoletimSanitario = idMensagemBoletimSanitario
		this.id = id
	},

	ADM_FARMACO: function ADM_FARMACO(
			nmPrincipioAtivo = [],
			dtInicioTratamento = null,
			dtLiberacaoAbate = null,
			blAtendeuCarencia = false,
			blConfirmado = false,
			flVacina = false,
			cdEntradaRacao = null,
			idAdmFarmaco = null,
			id = null,
		) {
		this.nmPrincipioAtivo = nmPrincipioAtivo.map(pa => pa.nmPrincipioAtivo).join(' / ')
		this.dtInicioTratamento = dtInicioTratamento
		this.dtLiberacaoAbate = dtLiberacaoAbate
		this.blAtendeuCarencia = blAtendeuCarencia
		this.blConfirmado = blConfirmado
		this.flVacina = flVacina
		this.cdEntradaRacao = cdEntradaRacao
		this.idAdmFarmaco = idAdmFarmaco
		this.id = id
	},
	MERCADO_DESTINO: function MERCADO_DESTINO(
			dsMercadoDestino = '',
			idMercadoDestino = 0,
			lstCdMensagemBoletimSanitario = []) {
		this.dsMercadoDestino = dsMercadoDestino
		this.idMercadoDestino = idMercadoDestino
		this.lstCdMensagemBoletimSanitario = lstCdMensagemBoletimSanitario
	},

	BOLETIM_SANITARIO: function BOLETIM_SANITARIO(
			{
				idBoletimSanitario = null,
				csResponsavelInformacoes = 'MO',
				csRastreabilidade = '',
				dtEmissao = '',
				hrEmissao = '',
				dtRetiradaRacao = '',
				hrRetiradaRacao = '',
				qtAnimais = 0,
				qtAnimaisRemanescentes = 0,
				peMortalidadeEmissao = 0,
				peMortalidadeFinalLote = 0,
				dsSinaisClinicos = '',
				cdLoteProducao = null,
				cdMunicipioEmissao = null,
				cdVeterinario = null,
				cdResponsavelTecnico = null,
				blNotificacaoObrigatoria = false,
				blCancelado = false,
				cdStatusBoletimSanitario = 0,
				saidaAnimais = [],
				lstSaidaAnimais = [],
				admFarmacos = [],
				sinaisClinicos = [],
				lstCdMercadosDestinos = [],
				mercadosDestino = [],
			}) {

		this.idBoletimSanitario = idBoletimSanitario
		this.csResponsavelInformacoes = csResponsavelInformacoes
		this.csRastreabilidade = csRastreabilidade
		this.dtEmissao = dtEmissao
		this.hrEmissao = hrEmissao
		this.dtRetiradaRacao = dtRetiradaRacao
		this.hrRetiradaRacao = hrRetiradaRacao
		this.qtAnimais = qtAnimais
		this.qtAnimaisRemanescentes = qtAnimaisRemanescentes
		this.peMortalidadeEmissao = peMortalidadeEmissao
		this.peMortalidadeFinalLote = peMortalidadeFinalLote
		this.dsSinaisClinicos = dsSinaisClinicos
		this.cdLoteProducao = cdLoteProducao
		this.cdMunicipioEmissao = cdMunicipioEmissao
		this.cdVeterinario = cdVeterinario
		this.cdResponsavelTecnico = cdResponsavelTecnico
		this.blNotificacaoObrigatoria = blNotificacaoObrigatoria
		this.blCancelado = blCancelado
		this.cdStatusBoletimSanitario = cdStatusBoletimSanitario
		this.saidaAnimais = saidaAnimais
		this.lstSaidaAnimais = lstSaidaAnimais
		this.admFarmacos = admFarmacos
		this.sinaisClinicos = sinaisClinicos
		this.mercadosDestino = mercadosDestino
		this.lstCdMercadosDestinos = lstCdMercadosDestinos
	},

	MENSAGEM_BOLETIM_SANITARIO: function MENSAGEM_BOLETIM_SANITARIO(
			cdMensagemBoletimSanitario,
			cdMercadoDestino,
			dsMensagemBoletim,
	) {
		this.cdMensagemBoletimSanitario = cdMensagemBoletimSanitario
		this.cdMercadoDestino = cdMercadoDestino
		this.dsMensagemBoletim = dsMensagemBoletim
	},

	TIPO_RESPONSAVEL_INFORMACOES: [
		{dsResponsavelInformacoes : "Médico Veterinário Oficial/Habilitado", csResponsavelInformacoes : "MO"},
		{dsResponsavelInformacoes : "Médico Veterinário Particular", csResponsavelInformacoes : "MP"},
		{dsResponsavelInformacoes : "Proprietário", csResponsavelInformacoes : "PR"},
	],


	TIPO_RASTREABILIDADE: [
		{dsRastreabilidade: 'Ciclo completo', csRastreabilidade: 'CC'},
		{dsRastreabilidade: 'Reprodutor/Descarte', csRastreabilidade: 'RD'},
		{dsRastreabilidade: 'Terminador', csRastreabilidade: 'TE'}
	],

	HEADERS_SAIDA_ANIMAIS: [
		{
			text: 'Nº Carga',
			align: 'start',
			sortable: false,
			value: 'nrCarga',
			class: "grey lighten-2  rounded-tl"
		},
		{
			sortable: false,
			text: "",
			value: "data-table-select",
			width: "1px",
			class: "grey lighten-2"
		},
		{
			text: 'Data',
			align: 'start',
			sortable: true,
			value: 'dtSaida',
			class: "grey lighten-2"
		},
		{
			text: 'Nº GTA',
			align: 'start',
			sortable: true,
			value: 'nrGta',
			class: "grey lighten-2"
		},
		{
			text: 'Qntd de animais',
			align: 'start',
			sortable: true,
			value: 'qtAnimais',
			class: "grey lighten-2"
		},
		{
			text: 'Destino',
			align: 'start',
			sortable: true,
			value: 'cdPlantaAbate',
			class: "grey lighten-2 rounded-tr"
		},
	],
	HEADERS_MEDICACAO: [
		{
			text: 'Princípio Ativo',
			align: 'start',
			sortable: true,
			value: 'dsPrincipioAtivo',
			class: "grey lighten-2  rounded-tl",
			isSelectable: true
		},
		{
			text: 'Data Início',
			align: 'start',
			sortable: true,
			value: 'dtInicioTratamento',
			class: "grey lighten-2",
			isSelectable: true
		},
		{
			text: 'Liberação para Abate',
			align: 'start',
			sortable: true,
			value: 'dtLiberacaoAbate',
			class: "grey lighten-2",
			isSelectable: true
		},
		{
			text: 'Atendeu o período de carência?',
			align: 'start',
			sortable: true,
			value: 'blAtendeuCarencia',
			class: "grey lighten-2",
			isSelectable: true
		},
		{
			sortable: true,
			text: "Confirme as medicações aplicadas",
			value: "data-table-select",
			class: "grey lighten-2 rounded-tr",
			width: null,
			isSelectable: true
		},
	],
	HEADERS_VACINA: [
		{
			text: 'Data',
			align: 'start',
			sortable: true,
			value: 'dtInicioTratamento',
			class: "grey lighten-2  rounded-tl"
		},
		{
			text: 'Vacinas administradas',
			align: 'start',
			sortable: true,
			value: 'nmPrincipioAtivo',
			class: "grey lighten-2"
		},
		{
			text: 'Atendeu o período de carência?',
			align: 'start',
			sortable: true,
			value: 'blAtendeuCarencia',
			class: "grey lighten-2"
		},
		{
			sortable: true,
			text: "Confirme as doses aplicadas",
			value: "data-table-select",
			class: "grey lighten-2 rounded-tr",
			width: null
		},
	],
	HEADERS_SINAL_CLINICO: [
		{
			text: 'Sintoma',
			align: 'start',
			sortable: true,
			value: 'nmSinalClinico',
			class: "grey lighten-2 rounded-tl"
		},
		{
			text: 'Data de aplicação',
			align: 'start',
			sortable: true,
			value: 'dtAplicacao',
			class: "grey lighten-2  rounded-tr"
		},
	],
}

export const RULES = {
	OBRIGATORIO: (v) => !v ? STRINGS.Obrigatorio : true,
  DATAEHORAOBRIGATORIA(value){
		if (!value) return false
    let validarFormato = moment(value, 'DD/MM/YYYY - HH:mm').format('DD/MM/YYYY - HH:mm') === value
    if(!validarFormato) return 'Data e hora obrigatórias'
    return true
  },
	DTSAIDAMAIORQUERETIRADARACAO: (ultimaDtSaida) => (dtRetiradaRacao) => {
		if (!ultimaDtSaida || !dtRetiradaRacao) return false

    return !moment(dtRetiradaRacao, 'YYYY-MM-DD').isAfter(moment(ultimaDtSaida, 'YYYY-MM-DD'))
	}
}

export const MOCKS = {
	SAIDAS_ANIMAIS: [
		{
			cdEntradaAnimais: null,
			cdEstabelecimentoDestino: null,
			cdLoteProducao: 843,
			cdPessoaProdutor: 511,
			cdPlantaAbate: 14,
			cdUnidadeExploracaoDestino: null,
			csTipoDestino: "AB",
			dhFimRegistro: null,
			dhUltimoUpdate: "2021-03-17T21:13:25.354611",
			dsPlacaCaminhao: "teste-16",
			dsSerieGta: "A",
			dtAbate: "2021-02-04",
			dtGta: "2021-02-03",
			dtSaida: "2021-02-01",
			hashTransaction: null,
			hrSaida: "12:20:00",
			idSaidaAnimais: 5502,
			nrGta: 321651,
			qtAnimais: 3,
			qtFemeas: 0,
			qtMachos: 3,
		},
		{
			cdEntradaAnimais: null,
			cdEstabelecimentoDestino: null,
			cdLoteProducao: 843,
			cdPessoaProdutor: 511,
			cdPlantaAbate: 14,
			cdUnidadeExploracaoDestino: null,
			csTipoDestino: "AB",
			dhFimRegistro: null,
			dhUltimoUpdate: "2021-03-17T21:14:25.354611",
			dsPlacaCaminhao: "teste-16",
			dsSerieGta: "A",
			dtAbate: "2021-02-04",
			dtGta: "2021-02-03",
			dtSaida: "2021-02-01",
			hashTransaction: null,
			hrSaida: "12:10:00",
			idSaidaAnimais: 5503,
			nrGta: 321652,
			qtAnimais: 7,
			qtFemeas: 0,
			qtMachos: 7,
		},
		{
			cdEntradaAnimais: null,
			cdEstabelecimentoDestino: null,
			cdLoteProducao: 843,
			cdPessoaProdutor: 511,
			cdPlantaAbate: 14,
			cdUnidadeExploracaoDestino: null,
			csTipoDestino: "AB",
			dhFimRegistro: null,
			dhUltimoUpdate: "2021-03-17T21:11:25.354611",
			dsPlacaCaminhao: "teste-16",
			dsSerieGta: "A",
			dtAbate: "2021-02-04",
			dtGta: "2021-02-03",
			dtSaida: "2021-02-01",
			hashTransaction: null,
			hrSaida: "12:00:00",
			idSaidaAnimais: 5504,
			nrGta: 321653,
			qtAnimais: 1,
			qtFemeas: 0,
			qtMachos: 1,
		},
	],
	ADM_MEDICAMENTOS: [
		{
			"nmPrincipioAtivo": "Neomicina (sulfato)",
			"dtInicioTratamento": "2020-03-28",
			"dtFimTratamento": "2020-04-03",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 11537,
			"idAdmFarmaco": 25183
		},
		{
			"nmPrincipioAtivo": "Tilmicosina",
			"dtInicioTratamento": "2020-03-25",
			"dtFimTratamento": "2020-03-28",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 11306,
			"idAdmFarmaco": 24623
		},
		{
			"nmPrincipioAtivo": "Amoxicilina triidratada",
			"dtInicioTratamento": "2020-03-26",
			"dtFimTratamento": "2020-03-26",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 25749
		},
		{
			"nmPrincipioAtivo": "Dipirona",
			"dtInicioTratamento": "2020-03-26",
			"dtFimTratamento": "2020-03-26",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 25750
		},
		{
			"nmPrincipioAtivo": "Amoxicilina triidratada",
			"dtInicioTratamento": "2020-03-27",
			"dtFimTratamento": "2020-03-27",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 25751
		},
		{
			"nmPrincipioAtivo": "Ácido latico / Ácido cítrico",
			"dtInicioTratamento": "2020-03-30",
			"dtFimTratamento": "2020-04-04",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 25739
		},
		{
			"nmPrincipioAtivo": "Dipirona",
			"dtInicioTratamento": "2020-03-27",
			"dtFimTratamento": "2020-03-27",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 25752
		},
		{
			"nmPrincipioAtivo": "Neomicina (sulfato)",
			"dtInicioTratamento": "2020-03-25",
			"dtFimTratamento": "2020-03-28",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 11306,
			"idAdmFarmaco": 24622
		},
		{
			"nmPrincipioAtivo": "Tilmicosina",
			"dtInicioTratamento": "2020-03-28",
			"dtFimTratamento": "2020-04-03",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 11537,
			"idAdmFarmaco": 25184
		},
		{
			"nmPrincipioAtivo": "Neomicina (sulfato)",
			"dtInicioTratamento": "2020-04-12",
			"dtFimTratamento": "2020-04-16",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 12241,
			"idAdmFarmaco": 26812
		},
		{
			"nmPrincipioAtivo": "Tilmicosina",
			"dtInicioTratamento": "2020-04-12",
			"dtFimTratamento": "2020-04-16",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 12241,
			"idAdmFarmaco": 26813
		},
		{
			"nmPrincipioAtivo": "Amoxicilina",
			"dtInicioTratamento": "2020-04-03",
			"dtFimTratamento": "2020-04-12",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 11877,
			"idAdmFarmaco": 26102
		},
		{
			"nmPrincipioAtivo": "Halquinol",
			"dtInicioTratamento": "2020-04-03",
			"dtFimTratamento": "2020-04-12",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": 11877,
			"idAdmFarmaco": 26103
		},
		{
			"nmPrincipioAtivo": "Amoxicilina",
			"dtInicioTratamento": "2020-04-13",
			"dtFimTratamento": "2020-04-18",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 27401
		},
		{
			"nmPrincipioAtivo": "Gentamicina",
			"dtInicioTratamento": "2020-03-31",
			"dtFimTratamento": "2020-04-04",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 27400
		},
		{
			"nmPrincipioAtivo": "Neomicina (sulfato)",
			"dtInicioTratamento": "2020-04-16",
			"dtFimTratamento": "2020-04-20",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": true,
			"cdEntradaRacao": 12562,
			"idAdmFarmaco": 27525
		},
		{
			"nmPrincipioAtivo": "Tilmicosina",
			"dtInicioTratamento": "2020-04-16",
			"dtFimTratamento": "2020-04-20",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": true,
			"cdEntradaRacao": 12562,
			"idAdmFarmaco": 27526
		},
		{
			"nmPrincipioAtivo": "Arginina / Fenilalanina / Histidina / Isoleucina / Lisina / Metionina / Treonina / Triptofano / Valina / Leucina / Vitamina B1 / Vitamina B6 / Sorbitol",
			"dtInicioTratamento": "2020-04-07",
			"dtFimTratamento": "2020-04-07",
			"blAtendeuCarencia": true,
			"blConfirmado": false,
			"flVacina": false,
			"cdEntradaRacao": null,
			"idAdmFarmaco": 27777
		}
	],
	SINAIS_CLINICOS: [
		{dsSinalClinico: 'Artrite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Eczema', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Encefalite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Entérico com sangue', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Lesão vesicular idiopática', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Morte súbita', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Refugos eliminados', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Artrite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Eczema', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Encefalite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Entérico com sangue', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Lesão vesicular idiopática', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Morte súbita', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Refugos eliminados', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Artrite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Eczema', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Encefalite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Entérico com sangue', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Lesão vesicular idiopática', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Morte súbita', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Refugos eliminados', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Artrite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Eczema', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Encefalite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Entérico com sangue', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Lesão vesicular idiopática', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Morte súbita', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Refugos eliminados', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Artrite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Eczema', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Encefalite', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Entérico com sangue', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Lesão vesicular idiopática', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Morte súbita', dtRegistro: '2020-10-30'},
		{dsSinalClinico: 'Refugos eliminados', dtRegistro: '2020-10-30'},
	],
	BOLETINS_SANITARIOS: [
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 1,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 2,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 3,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 4,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 5,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 6,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 7,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 8,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 9,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 10,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 11,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 12,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 13,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 14,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 15,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
		{
			nrLoteControle: '1234.1234',
			nmProdutor: 'Nome do Produtor Muito Grande',
			dhInicioRegitro: '2020-05-15',
			idBoletimSanitario: 16,
			listaSaidaAnimais: ["123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A", "123456-A"]
		},
	],
}